// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const budgetInAlertThresholdPctDefault = 80;
export const budgetInAlertThresholdPctMax = 100;

export const budgetInHardStopDefault = true;
export const budgetInLimitUsdOneMin = 0;
export const budgetInLimitUsdOneMax = 1000000;

export const BudgetIn = zod.object({
  "alert_threshold_pct": zod.int().min(1).max(budgetInAlertThresholdPctMax).default(budgetInAlertThresholdPctDefault),
  "hard_stop": zod.boolean().default(budgetInHardStopDefault),
  "limit_usd": zod.union([zod.number().min(budgetInLimitUsdOneMin).max(budgetInLimitUsdOneMax),zod.string()])
});

export type BudgetIn = zod.input<typeof BudgetIn>;
export type BudgetInOutput = zod.output<typeof BudgetIn>;
